module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Sale#1-b4e45902d30a699237f1cf2559524455.svg";